/** Keep local browser balance reads on the application origin. */
export function localProfileBalanceUrl(url: string, pageUrl?: string): string {
  if (!pageUrl) return url;
  const loopbackPage = /^http:\/\/(localhost|127\.0\.0\.1|\[::1\])(?::\d+)?(?=[/?#]|$)/i;
  const balanceTarget = /^http:\/\/(localhost|127\.0\.0\.1|\[::1\]):8100\/api\/v1\/profile\/balances$/i;
  if (!loopbackPage.test(pageUrl) || !balanceTarget.test(url)) return url;
  try {
    const page = new URL(pageUrl);
    if (page.username || page.password) return url;
    return "/api/local/profile-balance";
  } catch {
    return url;
  }
}
